import { render, staticRenderFns } from "./vipPrice-drawer.vue?vue&type=template&id=1abb9a99&"
import script from "./vipPrice-drawer.vue?vue&type=script&lang=js&"
export * from "./vipPrice-drawer.vue?vue&type=script&lang=js&"
import style0 from "./vipPrice-drawer.vue?vue&type=style&index=0&id=1abb9a99&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports